D.Lang = {};
D.Lang.get = function ( string, placeholder, lang = null ) {
	lang = lang || D.LANG;
	if( !isset(D.Language[lang]) || !isset(D.Language[lang][string]) ) {
		if (D.DEV && typeof placeholder === "undefined") {
			console.warn(`Missing lang "${string}"`);
		}
		if( isset(placeholder) ) {
			return placeholder;
		} else if( !D.DEV && lang !== 'en' ) {
			return this.get(string, placeholder, 'en');
		} else {
			return string;
		}
	}
	return D.Language[lang][string];
};
D.Lang.nget = function ($n, string) {
	let $plural = D.Lang.plural($n);
	let k = string + ($plural ? '_' + $plural : '');
	return D.Lang.get(k).replace('%s', $n);
};
D.Lang.plural = function ($n) {
	let $plural;
	switch (D.LANG) {
		case 'lv':
			/*
			 * _1 vienskaitlis
			 * _2 daudzskaitlis
			 * */
			$plural = ($n % 10 === 1 && $n % 100 !== 11 ? '1' : '2');
			break;
		case 'en':
		case 'de':
			/*
			 * _1 - vienskaitlis
			 * _2 - daudzskaitlis
			 * */
			$plural = String(($n !== 1 ? 1 : 0) + 1);
			break;
		default:
			$plural = '1';
			break;
	}
	return $plural
};
D.Lang.getBraintree = function(){
	let keys = {};
	Object.keys(D.Language[D.LANG]).filter(key => key.substr(0, 18) === "profile.braintree.").forEach(key => {
		keys[key.substr(18)] = D.Language[D.LANG][key];
	});
	return keys;
};
D.Lang.exists = function ( string ) {
	return isset(D.Language[D.LANG]) && isset(D.Language[D.LANG][string]);
};
D.Lang.rget = function ( string, replaces ) {
	let text = D.Lang.get(string);
	if( replaces ) {
		replaces.forEach(replace => {
			text = text.replace(replace.pattern, replace.value)
		});
	}
	return text;
};
D.Lang.t = function() {
	return this.get(...arguments);
};

window.t = D.Lang.t.bind(D.Lang);